import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import PersistProvider from './store/persist-provider';
import Routes from './routes';
import ToastContainer from './notifications/ToastContainer';
import { setupInterceptors } from './api/config';

// Wire the Redux store into the axios 401-refresh interceptor.
// Must happen before any API calls so the interceptor can dispatch LOGOUT_USER.
setupInterceptors(store);

// NOTE: The legacy `sessionCheckAction` (which called the now-removed
// `GET /auth/me` endpoint) used to fire here. Both V1 and V2 manage auth via
// localStorage JWTs (distill_auth_token / distill_guest_token) — the redux
// session check was orphaned and only produced a 404 on every page load.

const App: React.FC = () => (
  <Provider store={store}>
    <PersistProvider>
      <Router>
        <Routes />
        <ToastContainer />
      </Router>
    </PersistProvider>
  </Provider>
);

export default App;
